import { render, staticRenderFns } from "./Six.vue?vue&type=template&id=b54dc49c&scoped=true"
import script from "./Six.vue?vue&type=script&lang=js"
export * from "./Six.vue?vue&type=script&lang=js"
import style0 from "./Six.vue?vue&type=style&index=0&id=b54dc49c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54dc49c",
  null
  
)

export default component.exports